module.exports = __webpack_public_path__ + "static/media/waterPumpIcon.ef4d1df6.svg";